<template>
  <span data-node-content class="text-headline-new" data-cy="formula-operator">
    {{ node.content }}
  </span>
</template>

<script lang="ts" setup>
import type { MathOperator } from "@/enums/customAttributes";
import type { EditorNode } from "@/models/TextEditor";

interface OperatorNode extends Omit<EditorNode, "content"> {
  content: MathOperator;
}

defineProps<{
  node: OperatorNode;
}>();
</script>
